import React, { useState } from "react"
import Slider from "react-slick"
import ReactHTMLParser from "react-html-parser"
import YoutubeEmbed from "../youtube-embed/YouTubeEmbed"
import Svg from "../../shared/_svgs/svg"
import "./_testimonial-container.scss"
import TestimonialModal from "../modal/testimonial-modal"

export default function TestimonialContainerComponent({ testimonialContent, headline }) {
  const [overlayRichtext, setOverlayRichtext] = useState("")
  const [overlayQuote, setOverlayQuote] = useState("")
  const [toggleOverlay, setToggleOverlay] = useState(false)

  const handleOverlay = () => {
    setToggleOverlay(!toggleOverlay)
  }

  var settings = {
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    variableWidth: false,
    accessibility: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "4%",
        },
      },
    ],
  }

  const htmlTestimonialContent =
    testimonialContent.length > 0
      ? testimonialContent.map((t) => {
          return (
            <TestimonialItem
              key={t.testimonialHeading}
              isImage={t.isImageFormat}
              image={t.testimonialImage || undefined}
              isVideo={t.isVideoFormat}
              youtube={t.videoId || undefined}
              ariaVideoDescription={t.ariaVideoDescription}
              testimonialHeading={t.testimonialHeading}
              testimonial={t.testimonial}
              quote={t.testimonialQuote || ""}
              readMore={t.testimonialReadMore || ""}
              handleOverlay={handleOverlay}
              setOverlayRichtext={setOverlayRichtext}
              setOverlayQuote={setOverlayQuote}
              toggleOverlay={toggleOverlay}
            />
          )
        })
      : null

  return (
    <section className="block-container">
      <div className="testimonial-container">
        <div className="w--normal">
          <h3 className="testimonial-theme-text">{headline}</h3>
          <Slider {...settings}>{htmlTestimonialContent}</Slider>
          <div className="slideritems">/ {testimonialContent.length} )</div>
          {toggleOverlay ? (
            <TestimonialModal modalOpen={toggleOverlay} modalRichtext={overlayRichtext} modalQuote={overlayQuote} closeHandler={handleOverlay} />
          ) : null}
        </div>
      </div>
    </section>
  )
}

function TestimonialItem({
  isVideo,
  isImage,
  testimonialHeading,
  testimonial,
  image,
  youtube,
  ariaVideoDescription,
  quote,
  readMore,
  handleOverlay,
  setOverlayRichtext,
  setOverlayQuote,
  toggleOverlay,
}) {
  const htmlTestimonial = ReactHTMLParser(testimonial)

  const handleModalToggle = () => {
    if (toggleOverlay) {
      setOverlayRichtext(undefined)
      setOverlayQuote(undefined)
      handleOverlay()
      return
    }

    setOverlayRichtext(htmlTestimonial)
    setOverlayQuote(quote)
    handleOverlay()
  }

  return (
    <div className={`testimonial-item ${isVideo ? " video-format" : isImage ? " image-format" : ""}`}>
      <div className="textarea">
        <h4>{testimonialHeading}</h4>
        <div className="maintext">{htmlTestimonial}</div>
      </div>
      <div className="imagearea">
        {
          //if image, show image markup
          isImage && image ? (
            <img src={image} />
          ) : //if video, show video markup
          isVideo && youtube ? (
            <YoutubeEmbed
              embedId={youtube}
              classDecleration={"testimonial-video"}
              backgroundImage={image}
              ariaVideoDescription={ariaVideoDescription}
            />
          ) : undefined
        }
        <div className="testimonial">
          <Svg iconName="quote" fillColor="white"></Svg>
          {quote}
        </div>
      </div>
      <a className="readmorelink" onClick={handleModalToggle}>
        {readMore}
      </a>
    </div>
  )
}
